import CartConfig from "@system/config/cart";
import { __remove, __set } from "../store/axios_indicator";
import liveAuth from "../helper/liveAuth";
import System from "src/helper/system";
import Constants from "src/helper/Constants";
import Api from "src/service/APIHandler";
import Helper from "src/helper/Helper";

const API = new Api({});
const shipToAddressId = System.getUserShippingAddress() // MERCURY SYSTEMS, INC.
const { avUserInfoData: { speedBoatAbbr, currentUser }, storageName: { GUEST_SESSION_ID, CART_ID } } = System
const { currencyType: { USD }, CartType: { SHOPPING }, siteUser: { CORE }, downloadMsg } = Constants
const speedBoat = speedBoatAbbr;
class CartAPICall {

    getCartCount = async () => {
        let res = { data: { count: 0 } };
        let data = {
            type: SHOPPING,
            speedboat: speedBoat
        }

        let url = CartConfig.GUEST_CART_COUNT;

        if (liveAuth.check()) {
            url = CartConfig.CART_COUNT;
            data = { ...data, shipToAddressId: shipToAddressId }
        } else {
            data = { ...data, sessionId: localStorage.getItem(GUEST_SESSION_ID) }

        }
        const param = {
            data: data
        }
        await API.post(url, param).then((resHer) => {
            if (resHer.data) {
                res = resHer?.data
            }
        });
        return res;
    };

    addCartInBulk = async (params) => {
        __set('CART_OPERATION_API_CALL');
        let res = {};
        const param = {}
        let url = CartConfig.GUEST_ADD_TO_CART_IN_BULK;
        if (liveAuth.check()) {
            params = { ...params, currency: USD, shipToAddressId: shipToAddressId }
            url = CartConfig.ADD_TO_CART_IN_BULK;
        } else {
            params = { ...params, currency: USD, sessionId: localStorage.getItem(GUEST_SESSION_ID), speedboat: speedBoat }

        }
        param.data = params
        try {
            await API.post(url, param).then((resHer) => {
                if (resHer.data) {
                    res = resHer?.data
                }
            });
        } catch (error) {
            __remove('CART_OPERATION_API_CALL');
        }

        __remove('CART_OPERATION_API_CALL');
        return res;
    };

    addToCartServer = async (params) => {
        __set('CART_OPERATION_API_CALL');
        let res = {};
        const param = {}
        let url = CartConfig.GUEST_ADD_TO_CART
        param.data = { ...params, currency: USD, speedboat: speedBoat }

        if (!liveAuth.check()) {
            param.data = { ...param.data, sessionId: localStorage.getItem(GUEST_SESSION_ID) }
        } else {
            url = CartConfig.ADD_TO_CART;
            if (currentUser === CORE) {
                param.data = { ...param.data, shipToAddressId: shipToAddressId }
            }
        }

        try {
            await API.post(url, param).then((resHer) => {
                if (resHer.data) {
                    res = resHer?.data
                    const cartId = resHer?.data?.data?.cartId
                    this.storeCartIdInSession(cartId)
                }
            });
        } catch (e) {
            __remove('CART_OPERATION_API_CALL');
        }
        __remove('CART_OPERATION_API_CALL');
        return res
    };

    updateToCartServer = async (params) => {
        __set('CART_OPERATION_API_CALL');
        let res = {};
        const param = {}
        param.data = {
            "quantity": params?.quantity,
            "currency": USD,
            "backOrderedQuantity": params?.backOrderedQuantity,
            "cpn": params.cpn,
            "referencePartNumber": params.referencePartNumber,
            "quoteLineNumber": params.quoteLineNumber,
            "addedFromBom": params.addedFromBom,
            "vendorCode": params.vendorCode,
            "sapMatGroup": params.sapMatGroup,
            "cartDetailId": params.cartDetailId,
            'cartId': "",
            'partNumber': params.partNumber,
            "default_plant": params.default_plant,
            "mdmMaterialId": params.mdmMaterialId,
            "endCustAccNum": params.endCustAccNum
        }
        await API.put(CartConfig.UPDATE_TO_CART, param).then((resHer) => {
            if (resHer.data) {
                res = resHer?.data
            }
        });
        __remove('CART_OPERATION_API_CALL');
        return res
    };

    updateCartItemsServer = async (params) => {
        let res = {};
        const param = {}

        param.data = params
        await API.post(CartConfig.UPDATE_CART_ITEMS_BULK, param).then((resHer) => {
            if (resHer.data) {
                res = resHer?.data
            }
        });
        return res
    }

    updateBackOrderQuantityToCartServer = async (params) => {
        __set('CART_OPERATION_API_CALL');
        let res = {};
        const param = {}

        param.data = params
        await API.post(CartConfig.UPDATE_BACKORDER_QUANTITY_TO_CART, param).then((resHer) => {
            if (resHer.data) {
                res = resHer?.data
            }
        });
        __remove('CART_OPERATION_API_CALL');
        return res
    };

    getCartFromServer = async (params) => {
        let res = {};
        let url = CartConfig.GUEST_CART_VIEW;
        let param = {}
        param.data = {
            type: SHOPPING,
            miniCart: params?.miniCart || false,
            speedboat: speedBoat
        }
        if (liveAuth.check()) {
            url = CartConfig.VIEW_CART;
            param.data = {
                ...param.data,
                shipToAddressId: currentUser === CORE ? shipToAddressId : null
            }
        } else {
            param.data = { ...param.data, sessionId: localStorage.getItem(GUEST_SESSION_ID), }
        }
        __set("GET_CART_API_CALL")
        await API.post(url, param).then((resHer) => {
            if (resHer?.data?.data) {
                res.data = resHer.data?.data?.cartItems || {}
                res.orderId = resHer.data?.data?.orderId || 0

                const cartId = resHer?.data?.data?.cartItems?.[0]?.cartId
                this.storeCartIdInSession(cartId)
            }
        }).finally(() => {
            __remove("GET_CART_API_CALL")
        });

        return res
    };

    clearAllCartFromServer = async () => {
        let res = {};
        const param = {}

        param.params = { cartId: localStorage.getItem(CART_ID) }
        __set("CLEAR_CART_API_CALL")
        await API.delete(CartConfig.COMPLETELY_CLEAR_CART, param).then((resHer) => {
            sessionStorage.removeItem(CART_ID)
            if (resHer.data) {
                res = resHer?.data
            }
        }).finally(() => {
            __remove("CLEAR_CART_API_CALL")
        });
        return res;
    }

    clearSingleCartProduct = async (cartDetailId) => {
        let res = {};
        const param = {}

        param.params = {
            cartDetailId
        }
        await API.delete(CartConfig.CLEAR_SINGLE_PRODUCT_FROM_CART, param).then((resHer) => {
            if (resHer.data) {
                res = resHer?.data
            }
        });
        return res;
    };

    scheduleShippingApply = async (params) => {
        let res = {};
        const param = {}

        param.data = params
        await API.post(CartConfig.SCHEDULE_SHIPPING_APPLY, param).then((resHer) => {
            if (resHer.data) {
                res = resHer?.data
            }
        });
        return res;
    };

    exportCartData = async (fileType) => {
        let open_pdf_detected = false;

        if (fileType === 'open_pdf') {
            open_pdf_detected = true;
            fileType = 'pdf'
        }
        const param = {}

        param.data = {
            fileType,
            "type": "Shopping"
        };
        await API.post(CartConfig.EXPORT_CART_DATA, param).then((resHer) => {
            if (open_pdf_detected === true) {
                let file = new Blob([resHer.data], { type: 'application/pdf' });
                let fileURL = URL.createObjectURL(file);
                let blobURL = fileURL;
                let iframe = document.createElement('iframe'); //load content in an iframe to print later
                document.body.appendChild(iframe);
                iframe.style.display = 'none';
                iframe.src = blobURL;
                iframe.onload = function () {
                    setTimeout(function () {
                        iframe.focus();
                        iframe.contentWindow.print();
                    }, 1);
                };
                return;
            }
            if (resHer?.data) {
                Helper.downloadFileFromRes(resHer.data, 'Cart.' + param?.data?.fileType)
            }
        });
    };

    checkItemExistsInCart = async (params) => {
        let res = {};
        let data = {
            ...params,
            type: SHOPPING
        }

        if (!liveAuth.check()) {
            data = { ...data, sessionId: localStorage.getItem(GUEST_SESSION_ID) }
        } else {
            data = { ...data, shipToAddressId: System.getUserShippingAddress() }
        }
        let param = { data: data }
        try {
            await API.post(CartConfig.CHECK_CART_ITEM_EXIST, param).then((resHer) => {
                if (resHer.data?.data) {
                    res = resHer.data?.data?.itemsExists
                }
            });
        } catch (e) {
            res = false
        }
        return res;
    };

    replaceCartInBulk = async (params) => {
        let res = {};
        let data = {
            ...params,
            type: SHOPPING,
            speedboat: speedBoat,
            currency: USD,
        }
        if (!liveAuth.check()) {
            data = { ...data, sessionId: localStorage.getItem(GUEST_SESSION_ID) }
        } else {
            data = { ...data, shipToAddressId: shipToAddressId }
        }
        let param = { data: data }

        await API.post(CartConfig.REPLACE_TO_CART_IN_BULK, param).then((resHer) => {
            if (resHer.data) {
                res = resHer?.data
            }
        });
        return res
    };

    getValidateCartFromServer = async (params) => {
        let res = {};
        if (!liveAuth.check()) {
            return res;
        }

        let param = {}
        param.data = {
            "cartId": localStorage.getItem(CART_ID),
            "shipToAddressId": params.shipToAddressId,
            "type": SHOPPING
        }
        __set('VALIDATE_CART_API_CALL');
        await API.post(CartConfig.VALIDATE_CART, param).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data?.data || {}
            }
        });
        __remove('VALIDATE_CART_API_CALL')
        return res
    };

    storeCartIdInSession = (id) => {
        if (localStorage.getItem(CART_ID) !== undefined) {
            let updatedId = localStorage.getItem(CART_ID)
            if (updatedId !== id) {
                localStorage.setItem(CART_ID, id);
            }
        } else {
            localStorage.setItem(CART_ID, id);
        }
    };

    addComplianceData = async (params) => {
        __set("ADD_COMPLIANCE_DATA");

        let res = {};
        if (!liveAuth.check()) {
            return res;
        }
        const param = {}
        param.data = params

        try {
            await API.post(CartConfig.ADD_COMPLIANCE_DATA, param).then((resHer) => {
                if (resHer.data) {
                    res = resHer?.data
                }
            });
        } catch (error) {
            res = error?.response?.data
        } finally {
            __remove("ADD_COMPLIANCE_DATA");
        }
        return res;
    };

    getComplianceData = async (params) => {
        __set("GET_COMPLIANCE_DATA");

        let res = {};
        if (!liveAuth.check()) {
            return res;
        }
        const param = {}
        param.params = params

        try {
            await API.get(CartConfig.GET_COMPLIANCE_DATA, param).then((resHer) => {
                if (resHer.data) {
                    res = resHer?.data
                }
            });
        } catch (error) {
            res = error?.response?.data
        } finally {
            __remove("GET_COMPLIANCE_DATA");
        }
        return res;
    };

    fetchCartTax = async (params) => {
        __set('CART_TAX_API_CALL')
        let res = {};
        if (!liveAuth.check()) {
            return res;
        }
        const param = {}
        param.data = params
        await API.post(CartConfig.CART_CALCULATE_TAX, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data?.data
            }
        }).catch((err) => {
            __remove("CART_TAX_API_CALL");
            res = {
                tax: "0",
                tariff: "0"
            }
        })
        __remove("CART_TAX_API_CALL");
        return res;
    }
    
    mergeGuestCartItems = async () => {
        let res = {};
        let param = {}
        param.data = {
            "sessionId": localStorage.getItem(GUEST_SESSION_ID),
            "shipToAddressId": System.getUserShippingAddress(),
            "speedboat": speedBoat
        }
        await API.post(CartConfig.GUEST_MERGE_CART_ITEMS, param).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data || {}
            }
        });
        return res
    };

    getPaymentToken = async (baseURL, cssURL) => {
        __set("GET_PAYMENT_TOKEN");
        let res = {};

        try {
            await API.get(CartConfig.GET_PAYMENT_TOKEN + `?baseURL=${baseURL}&cssURL=${cssURL}`).then((resHer) => {
                if (resHer?.data?.data) {
                    res = resHer.data || {}
                }
            });
        } catch (error) {
            res = error?.response?.data
        }

        __remove("GET_PAYMENT_TOKEN");
        return res
    };
}

export default CartAPICall;